/* eslint-disabled */
import EngineArgument from "./EngineArgument";
import EngineMethodLine from "./EngineMethodLine";
import EnginePlaceExtend from "@/entity/extends/EnginePlaceExtend";
import {helper} from "@/services/Helper";
import { hydrateCollection } from "@/Utils/EntityHelper";

export default class EnginePlace extends EnginePlaceExtend {

    public id!: number;
    public uuid = helper.generateId();
    public argument!: EngineArgument;
    public callableArgumentPlaces: EnginePlace[] = [];
    public requirement?: number
    public symbol? = '';
    public value? = '';

    constructor(object?: any) {
        super(object)
        if (object) {
            this.id = object.id;

            hydrateCollection(object.callableArgumentPlaces, EnginePlace, this.callableArgumentPlaces);

            this.argument = (object.argument instanceof EngineArgument) ? object.argument : object.argument ? new EngineArgument(object.argument) : object.argument;
            this.symbol = object.symbol;
            this.requirement = object.requirement
            this.uuid = object.uuid
            this.value = object.value;
        }
        this.postConstruct()
    }

}
